import { StepType } from '@reactour/tour';

export const tourSteps: StepType[] = [
  {
    selector: '.step-1',
    content: 'Here you can check progress of Pritset usage',
  },
  {
    selector: '.step-7',
    content: 'Now lets go to templates page',
  },
  {
    selector: '.step-8',
    content: 'Here you can manage templates which are used in API template processings',
  },
  {
    selector: '.step-9',
    content: 'This is also unique id which exactly for API template processings',
  },
  {
    selector: '.step-10',
    content: 'Now lets got and create new template',
  },
  {
    selector: '.step-11',
    content: 'Pass Template name, some tages if needed, template file and press Save',
  },
  {
    selector: '.step-8',
    content: 'Now you have template to use for API template processing',
  },
  {
    selector: '.step-14',
    content:
      'By clicking this button you copy curl expression to clipboard that can be used in Postman or any other API testing tool to test your template',
  },
  {
    selector: '.step-12',
    content: 'Lets continue exploring to labs',
  },
  {
    selector: '.step-15',
    content: 'Select Webhook testing to send a dummy template response to a webhook endpoint.',
    action: (element) => (element as HTMLButtonElement | null)?.click(),
  },
  {
    selector: '.step-15',
    content:
      'Enter a webhook URL and press Test to send a dummy template response to that endpoint.',
    action: (element) => (element as HTMLButtonElement | null)?.click(),
  },
  {
    selector: '.step-16',
    content:
      'Select Template testing to preview a template and generate a document with test data.',
    action: (element) => (element as HTMLButtonElement | null)?.click(),
  },
  {
    selector: '.step-17',
    content:
      'Upload a .docx template, provide its JSON data, and press Generate to preview the result.',
  },
];
